import {
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField
} from "@mui/material";
import { styled } from "@mui/system";
import { NumericFormat } from "react-number-format";

const StyledTextField = styled(TextField)({
  minWidth: "80px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#E9EAEC",
    borderRadius: "10px"
  },
  "& .MuiInputBase-root.Mui-disabled": {
    backgroundColor: "rgb(255, 255, 255)",
    borderColor: "rgb(179, 179, 179)",
    outline: "none",
    "& fieldset": {
      borderColor: "rgb(179, 179, 179)",
      borderWidth: "0.5px"
    }
  }
});

export const Section11 = ({
  formState,
  handleChange,
  handleSectionComplete,
  reportId,
  isEditingEnabled
}) => {
  return (
    <Stack spacing={2}>
      <TableContainer sx={{ overflowX: "auto" }}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell align="center"></TableCell>
              <TableCell align="center">ብዛት</TableCell>
              <TableCell align="center">በካሬ</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>በመንግስት ምሪት የተገኘ አምልኮ ቦታ ብዛት</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.government_granted_places.number}
                  onValueChange={values => {
                    handleChange("properties", {
                      government_granted_places: {
                        number: values.floatValue
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.government_granted_places.area}
                  onValueChange={values => {
                    handleChange("properties", {
                      government_granted_places: {
                        area: values.floatValue
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>በግዢ የተገኘ የአምልኮ ቦታ ብዛት</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.purchased_places.number}
                  onValueChange={values => {
                    handleChange("properties", {
                      purchased_places: { number: values.floatValue }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.purchased_places.area}
                  onValueChange={values => {
                    handleChange("properties", {
                      purchased_places: { area: values.floatValue }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>በስጦታ የተገኘ የአምልኮ ቦታ ብዛት</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.gifted_places.number}
                  onValueChange={values => {
                    handleChange("properties", {
                      gifted_places: { number: values.floatValue }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.gifted_places.area}
                  onValueChange={values => {
                    handleChange("properties", {
                      gifted_places: { area: values.floatValue }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>በሊዝ የተገኘ አምልኮ ቦታ ብዛት</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.leased_places.number}
                  onValueChange={values => {
                    handleChange("properties", {
                      leased_places: { number: values.floatValue }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.leased_places.area}
                  onValueChange={values => {
                    handleChange("properties", {
                      leased_places: { area: values.floatValue }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>በክራይ ያሉ የአምልኮ ቦታ ብዛት</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.rented_places.number}
                  onValueChange={values => {
                    handleChange("properties", {
                      rented_places: { number: values.floatValue }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.rented_places.area}
                  onValueChange={values => {
                    handleChange("properties", {
                      rented_places: { area: values.floatValue }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>የግለሰብ ቤት በነፃ</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.church_owned_places.number}
                  onValueChange={values => {
                    handleChange("properties", {
                      church_owned_places: {
                        number: values.floatValue
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.church_owned_places.area}
                  onValueChange={values => {
                    handleChange("properties", {
                      church_owned_places: { area: values.floatValue }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>የማመለኪያ አዳራሽ ህንጻ ብዛት</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.worship_halls.number}
                  onValueChange={values => {
                    handleChange("properties", {
                      worship_halls: { number: values.floatValue }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.worship_halls.area}
                  onValueChange={values => {
                    handleChange("properties", {
                      worship_halls: { area: values.floatValue }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>የሁለገብ ህንጻ ብዛት</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.multi_purpose_buildings.number}
                  onValueChange={values => {
                    handleChange("properties", {
                      multi_purpose_buildings: {
                        number: values.floatValue
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.multi_purpose_buildings.area}
                  onValueChange={values => {
                    handleChange("properties", {
                      multi_purpose_buildings: { area: values.floatValue }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>የቀብር ቦታ</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.cemeteries}
                  onValueChange={values => {
                    handleChange("properties", {
                      cemeteries: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center"></TableCell>
            </TableRow>
            <TableRow>
              <TableCell>የመኪና</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.vehicles}
                  onValueChange={values => {
                    handleChange("properties", {
                      vehicles: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center"></TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ሞተር ሳይክልና ባለ ሦስት እግር ተሽከርካሪ ብዛት</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.motorcycles_and_three_wheelers}
                  onValueChange={values => {
                    handleChange("properties", {
                      motorcycles_and_three_wheelers: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center"></TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ቋሚና ሌሎች</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.fixed_and_others}
                  onValueChange={values => {
                    handleChange("properties", {
                      fixed_and_others: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center"></TableCell>
            </TableRow>
            <TableRow>
              <TableCell>መዋዕለ ሕጻናት ትምህርት ቤት ብዛት</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.kindergartens}
                  onValueChange={values => {
                    handleChange("properties", {
                      kindergartens: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center"></TableCell>
            </TableRow>
            <TableRow>
              <TableCell>1ኛ ደረጃ ትምህርት ቤት ብዛት</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.primary_schools}
                  onValueChange={values => {
                    handleChange("properties", {
                      primary_schools: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center"></TableCell>
            </TableRow>
            <TableRow>
              <TableCell>2ኛ ደረጃ ትምህርት ቤት ብዛት</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.secondary_schools}
                  onValueChange={values => {
                    handleChange("properties", {
                      secondary_schools: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center"></TableCell>
            </TableRow>
            <TableRow>
              <TableCell>መጽሕፍ ቅዱስ ትምህርት ቤት ብዛት</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.bible_schools}
                  onValueChange={values => {
                    handleChange("properties", {
                      bible_schools: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center"></TableCell>
            </TableRow>
            <TableRow>
              <TableCell>የመጽሐፍ ቅዱስ ኮሌጅ ብዛት</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.properties.bible_colleges}
                  onValueChange={values => {
                    handleChange("properties", {
                      bible_colleges: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center"></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {!reportId && (
        <Stack alignItems="flex-start">
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSectionComplete(12)}
          >
            ቀጥል
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
